import { css } from '@emotion/css';
import { theme } from 'Shared/ThemeProvider';

const singleColumnWidth = 900;


export function PosterBuilderWithPreview(P:{children})
{
	/* Read P.children ONCE. It is a getter: reading it per pane invokes it twice, which creates the
	   entry pane and the (expensive) PreviewTab builder twice over — two live builders, double the
	   resource fetches and saves. Solid's children() helper reads it once too, but it flattens a
	   pane that renders a fragment into loose nodes, so everything past the fragment's first node
	   lands in no pane at all and is never mounted. */
	const panes = P.children;

	const entryPaneStyle = css({
		display: 'inline-block',
		width: '50%',

		[`@media (max-width:${singleColumnWidth}px)`]: {
			width: '100%',
		},
	});

	const previewStyle = css({
		display: 'block',
		width: '48%',
		float: 'right',
		position: 'sticky',
		top: `calc(${theme().nav.height} + 1em)`,

		[`@media (max-width:${singleColumnWidth}px)`]: {
			width: '100%',
			float: 'none'
		},
	});

	return (
		<div>
			<div class={entryPaneStyle}>
				{panes[0]}
			</div>

			<div class={previewStyle}>
				{panes[1]}
			</div>
		</div>
	);
}

